import axios from 'axios';
import { message } from 'antd';
import {
  PRODUCT_RESTRICTIONS_API,
} from '../../../constants/API';
import {
  CREATE_PRODUCT_RESTRICTION_LOADING
} from '../types';
import getProductRestrictions from './getProductRestrictions';

function createProductRestriction(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: CREATE_PRODUCT_RESTRICTION_LOADING,
        creatingProductRestriction: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const hide = message.loading('Creating Product Restriction', 0);

        const { userData } = getState().AuthReducer;
        const postData = {
          ...data,
          userId: userData.id
        };
        await axios.post(PRODUCT_RESTRICTIONS_API, postData, { headers: {"Authorization" : `Bearer ${accessToken}`} });
        hide()
        dispatch({
          type: CREATE_PRODUCT_RESTRICTION_LOADING,
          creatingProductRestriction: false
        });
        await dispatch(getProductRestrictions());
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: CREATE_PRODUCT_RESTRICTION_LOADING,
          creatingProductRestriction: false
        });
        console.log(e);
      }
  }
}
export default createProductRestriction;
